module.exports = __webpack_public_path__ + "static/media/hayon1.4af6c1b8.jpg";